import { atom } from "jotai";

import { employeeApi } from "../services";
import type { EmployeeOption } from "../types";

export const employeesAtom = atom<EmployeeOption[]>([]);

export const employeesLoadingAtom = atom(false);

/**
 * Whether the roster has answered, which is not the same as a request being in
 * flight: a form paints before its effect asks, and a card that reads the
 * roster is only half itself until then.
 */
export const employeesLoadedAtom = atom(false);

/**
 * The roster, read once and kept: it changes far more slowly than a form is
 * opened, and the picker filters it itself. A form that shows the person it
 * named reads their name from here too.
 */
export const loadEmployeesAtom = atom(null, async (get, set): Promise<void> => {
  if (get(employeesLoadingAtom) || 0 < get(employeesAtom).length) {
    return;
  }

  set(employeesLoadingAtom, true);

  try {
    set(employeesAtom, await employeeApi.fetchEmployees());
  } catch {
    // The picker stays on what it had; saving is what reports a server that is
    // not answering.
  } finally {
    set(employeesLoadingAtom, false);
    set(employeesLoadedAtom, true);
  }
});
